export enum RegionTypes {
  Unknown = 0,
  // Canada
  Ontario = 1,
  Quebec = 2,
  BritishColumbia = 3,
  Alberta = 4,
  Manitoba = 5,
  Saskatchewan = 6,
  NewfoundlandAndLabrador = 7,
  NovaScotia = 8,
  PrinceEdwardIsland = 9,
  NewBrunswick = 10,
  NorthwestTerritories = 11,
  Nunavut = 12,
  Yukon = 13,
  // USA
  Ohio = 14
}
